<header cxSkipLink="cx-header" [cxFocus]="{ disableMouseFocus: true }" [class.is-expanded]="isExpanded$ | async"
    (keydown.escape)="collapseMenu()" (click)="collapseMenuIfClickOutside($event)">
    <cx-page-layout section="header"></cx-page-layout>
    <cx-page-layout section="navigation"></cx-page-layout>
</header>
<cx-page-slot position="BottomHeaderSlot"></cx-page-slot>
<app-uig-global-message></app-uig-global-message>
